// extracted by mini-css-extract-plugin
export default {"root":"VideoLessons_root__cjKCG","egg":"VideoLessons_egg__fjbE3","grid":"VideoLessons_grid__Mp2fG"};